import { createRouter, createWebHashHistory } from 'vue-router/dist/vue-router.mjs'

import appRoutes from './app'
import setupRoutes from './setup'

const routes = [
    ...appRoutes,
    ...setupRoutes,
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('@views/other/NotFound.vue'),
    }
]


// Router configuration 
const router = createRouter({
    history: createWebHashHistory(),
    routes: routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else if (to.name !== from.name) {
            return { top: 0 }
        }
    }

})

const routeAccessPermission = (to) => {
    return access(to.name)
}

router.beforeEach((to, from, next) => {
    if (routeAccessPermission(to)) {
        next()
    } else {
        next({ name: 'dashboard' })
    }
})

export default router